// 🟣 Modifié par Camille VEAUX
document.addEventListener("DOMContentLoaded", function () {
  const variantCheckboxes = document.querySelectorAll(
    ".mm-product-variant-checkbox"
  );
  const sizeDataElements = document.querySelectorAll("#SizeData");

  function updateSizeData() {
    const selectedVariants = Array.from(variantCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value.toLowerCase());

    sizeDataElements.forEach(function (element) {
      if (selectedVariants.includes(element.dataset.nomTaille.toLowerCase())) {
        // element.style.display = "flex";
        element.removeAttribute("id");
        element.classList.add("cve_show-size-data-container");
      } else {
        // element.style.display = "none";
        element.classList.remove("cve_show-size-data-container");
        element.id = "SizeData";
      }
    });
  }

  // Mettre à jour les informations de taille au chargement de la page
  updateSizeData();

  // Mettre à jour les informations de taille lorsque les cases à cocher changent
  variantCheckboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", updateSizeData);
  });
});
// 🟣 FIN
